const REQUEST_OMIT_THRESHOLD = 30;
const REQUEST_OMITTED_FIELDS = ['OMITTED_FIELD_REQUEST_HEADERS', 'OMITTED_FIELD_REQUEST_BODY'];

export default function buildOmitArgs(eventsRequested) {
  const requestOmitted = Number(eventsRequested) > REQUEST_OMIT_THRESHOLD;
  return {
    requestOmitted,
    omitArgs: requestOmitted ? { omittedFields: REQUEST_OMITTED_FIELDS } : {},
  };
}
